import { readableColor } from 'polished';

interface IGetWidgetColors {
  actionBackground?: string;
  contentBackground?: string;
  headerBackground?: string[];
}
export const getWidgetColors = ({ headerBackground, contentBackground, actionBackground }: IGetWidgetColors) => {
  const getContrastingTextColor = (bgColor?: string[] | string, lightColor?: string, darkColor?: string) => {
    if (!bgColor || !lightColor || !darkColor) {
      return '#000000';
    }

    if (Array.isArray(bgColor)) {
      if (bgColor?.length > 1) {
        return readableColor(bgColor[1], darkColor, lightColor, false);
      }

      return readableColor(bgColor[0], darkColor, lightColor, false);
    }

    return readableColor(bgColor, darkColor, lightColor, false);
  };

  return {
    backgroundColors: getContrastingTextColor(headerBackground, '#ffffff', '#141414'),
    borderColors: getContrastingTextColor(contentBackground, '#e8e8e8', '#444444'),

    buttonTextColor: getContrastingTextColor(actionBackground, '#fff', '#000'),

    cashbackColor: getContrastingTextColor(
      getContrastingTextColor(headerBackground, '#ffffff', '#141414'),
      '#ffffff',
      '#141414',
    ),

    contentColors: getContrastingTextColor(contentBackground, '#e8e8e8', '#444444'),

    grayTextColor: getContrastingTextColor(headerBackground, '#c5c5c5', '#666666'),

    placeholderHeaderTextColor: getContrastingTextColor(headerBackground, '#888888', '#a3a3a3'),

    textColor: getContrastingTextColor(headerBackground, '#fff', '#000'),
  };
};

export const getItemTextInvertedColor = () => 'var(--contentPrimary)';

export const getItemBorderInvertedColor = (borderColor?: string) => {
  if (borderColor) {
    return borderColor.includes('444') ? '#e8e8e8' : '#444444';
  }
};
